import React from 'react'
import { useIsContentSearchActive } from 'src/Utils/search/search.hooks'
import { useLocation, useNavigate } from 'react-router-dom'
import queryString from 'query-string'
import { useNavigateContext } from 'src/components/Reusable/Navigation/NavigateContext'
import {
  parseSearchQuery,
  searchOptionsToQuery,
} from 'src/Utils/search/search.helpers'
import { Switch } from '../../Switch/Switch'
import {
  ContentSearchContainer,
  ContentSearchLabel,
} from './ContentSearch.styles'

export const ContentSearch = ({ query }: { query: string }): JSX.Element => {
  const isContentSearchActive = useIsContentSearchActive()
  const location = useLocation()
  const searchParamsFallback = queryString.parse(location.search, {
    arrayFormat: 'bracket',
  })
  const navigateFallback = useNavigate()
  const {
    navigateState: {
      navigate,
      parsedQueryParams,
      locationSearchString: contextLocationSearchString,
    },
  } = useNavigateContext()
  const searchParams = parsedQueryParams || searchParamsFallback
  const locationSearchString = contextLocationSearchString || location.search
  const navigateFunc = navigate || navigateFallback

  const handleSwitch: React.ChangeEventHandler<HTMLInputElement> = () => {
    const urlQuery: queryString.StringifiableRecord = {
      ...searchParams,
      ['contentSearch']: 'true',
    }
    if (query) {
      const parsedQuery = parseSearchQuery(query)
      const searchStr = searchOptionsToQuery(parsedQuery)
      urlQuery['search'] = encodeURIComponent(searchStr)
    }
    const updatedHref = !isContentSearchActive
      ? queryString.stringifyUrl({
          url: location.pathname,
          query: urlQuery,
        })
      : queryString.exclude(`${location.pathname}${locationSearchString}`, [
          'contentSearch',
        ])
    navigateFunc(updatedHref)
  }

  return (
    <ContentSearchContainer>
      <Switch
        id="content-search-switch"
        checked={isContentSearchActive}
        onChange={handleSwitch}
        onMouseDown={(e) => e.preventDefault()}
      />
      <ContentSearchLabel>Search content</ContentSearchLabel>
    </ContentSearchContainer>
  )
}
